import angular from 'angular';

import KBYGModalController from './KBYGModalController';
import KBYGService from './KBYGFactory';


export default angular.module('app.lead.modal', [])
    .controller('KBYGModalController', KBYGModalController)
    .service('KBYGFactory', KBYGService)
    .run(($templateCache) => {
        $templateCache.put('app/lead/kbyg/modal/KBYGModalTemplate.html', require('./KBYGModalTemplate.html')); // eslint-disable-line global-require
        $templateCache.put('app/lead/kbyg/modal/KBYGBasicContentTemplate.html', require('./KBYGBasicContentTemplate.html')); // eslint-disable-line global-require
        $templateCache.put('app/lead/kbyg/modal/address/KBYGAddressTemplate.html', require('./address/KBYGAddressTemplate.html')); // eslint-disable-line global-require
        $templateCache.put('app/lead/kbyg/modal/addressBreakdown/KBYGAddressBreakdownTemplate.html', require('./addressBreakdown/KBYGAddressBreakdownTemplate.html')); // eslint-disable-line global-require
        $templateCache.put('app/lead/kbyg/modal/internalForm/KBYGInternalForm.html', require('./internalForm/KBYGInternalForm.html')); // eslint-disable-line global-require
        $templateCache.put('app/lead/kbyg/modal/zipcodeCheck/KBYGZipcodeCheckTemplate.html', require('./zipcodeCheck/KBYGZipcodeCheckTemplate.html')); // eslint-disable-line global-require
        $templateCache.put('app/lead/kbyg/modal/basicForm/KBYGBasicFormTemplate.html', require('./basicForm/KBYGBasicFormTemplate.html')); // eslint-disable-line global-require
    })
    .name;



// WEBPACK FOOTER //
// ./src/app/lead/kbyg/modal/index.js